<template>
  <Modal size="large" class="load-from-api-modal">
    <div class="modal-header">
      <div>
        <h5>
          <i
            class="fas fa-chevron-left"
            @click="backToNewSlideModal">
          </i>
          เลือกข้อมูลจากระบบ
        </h5>
        <button
          class="btn-close"
          @click.stop="$emit('update:showLoadFromAPIModal', false)">
          <i class="fas fa-times"></i>
        </button>
      </div>
      <div>
        <div class="dropdown">
          <p>เลือกจาก</p>
          <select
            v-model="loadFrom"
            @change="loadPage(1)">
            <option value="programs">รายการ</option>
            <option value="episodes">ตอน</option>
            <option value="videos">วิดีโอ</option>
            <option value="podcasts">พอตแคสต์</option>
          </select>
        </div>
      </div>
    </div>
    <div class="modal-body">
      <div class="list-container">
        <PreloaderSection
          v-if="loadFromAPIState.isLoading" />
        <div v-if="!loadFromAPIState.isLoading">
          <div
            v-if="!loadFromAPIState.error">
            <div class="search-container">
              <input
                class="form-control form-control-search"
                :placeholder="getSearchPlaceholder()"
                v-model="searchTerm"
                @input.prevent="onSearch" />
            </div>
            <div v-if="loadedData">
              <List>
                <template v-slot:list-header>
                  <div class="list-item-image"></div>
                  <div class="list-item-detail">
                    <div class="list-item list-item-primary">ชื่อ</div>
                    <div class="list-item">หมวดหมู่</div>
                    <div class="list-item list-item-status">สถานะ</div>
                    <div class="list-item list-item-action"></div>
                  </div>
                </template>
                <template v-slot:list-body>
                  <div class="list-item-container no-underline"
                       v-for="(item, itemIndex) in loadedData"
                       :key="itemIndex"
                       @click.stop="createSlideFromAPI(item)">
                    <div class="list-item-image">
                      <ImageView
                        :source="item.coverImage"
                        imageSize="cover160w90h" />
                    </div>
                    <div class="list-item-detail">
                      <div class="list-item list-item-primary list-item-title">
                        {{item.title}}
                      </div>
                      <div class="list-item">
                        {{getCategoryName(item)}}
                      </div>
                      <div class="list-item list-item-status">
                        <div class="badge badge-status"
                             :class="item.status">
                          {{item.status}}
                        </div>
                      </div>
                      <div class="list-item list-item-action">
                        <div class="action-container">
                          <button
                            class="btn btn-light btn-action"
                            @click.stop="createSlideFromAPI(item)">
                            เลือก
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </List>
            </div>
            <EmptyMessage v-if="!loadedData.length && !emptySearchResult">
              <h3>ไม่พบข้อมูล</h3>
            </EmptyMessage>
            <EmptyMessage v-if="emptySearchResult">
              <h3>ไม่พบรายการที่ค้นหา</h3>
              <button
                type="button"
                class="btn btn-light btn-lg mt-4"
                @click="clearSearch">
                ล้างผลการค้นหา
              </button>
            </EmptyMessage>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div
        class="pagination-container"
        v-if="isShowPagination()">
        <ul class="pagination text-center">
          <button
            class="page-link page-first link"
            @click="loadPage(1)"
            :disabled="page === 1">
            <i class="fas fa-angle-double-left"></i>
          </button>
          <button
            class="page-link page-previous link"
            @click="loadPage(previousPage)"
            :disabled="page === 1">
            <i class="fas fa-angle-left"></i>
          </button>
          <div v-for="n in lastPage" :key="n">
            <button
              :class="{ active: isActivePage(n) }"
              class="page-link link"
              @click="loadPage(n)"
              v-if="showPaginate(n)">
              {{ n }}
            </button>
          </div>
          <button
            class="page-link page-next link"
            @click="loadPage(nextPage)"
            v-if="page < lastPage || !page"
            :disabled="page === lastPage">
            <i class="fas fa-angle-right"></i>
          </button>
          <button
            class="page-link page-last link"
            v-if="page < (lastPage - 1) || !page"
            @click="loadPage(lastPage)">
            <i class="fas fa-angle-double-right"></i>
          </button>
        </ul>
      </div>
    </div>
  </Modal>
</template>

<script>
// Systems
import _ from 'lodash';
import Modal from '@/components/Modal.vue';
import PreloaderSection from '@/components/PreloaderSection.vue';
import List from '@/components/List.vue';
import EmptyMessage from '@/components/EmptyMessage.vue';
import ImageView from '@/image/ImageView.vue';

// APIs
import { loadProgramsByPage, searchProgramsInsideModal } from '@/program/api';
import { loadVideosByPage, searchVideosInsideModal } from '@/video/api';
import { loadEpisodesByPage, searchEpisodesInsideModal } from '@/episode/api';
import { loadTaxonomyByKey } from '@/taxonomy/api';
// TODO: LOAD PODCAST API

export default {
  props: {
    showLoadFromAPIModal: {
      type: Boolean,
      default: () => false,
    },
    allItems: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    Modal,
    PreloaderSection,
    List,
    ImageView,
    EmptyMessage,
  },
  data() {
    return {
      loadFrom: 'programs',
      searchTerm: '',
      loadFromAPIState: {
        isLoading: true,
        error: null,
      },
      contentCategories: null,
      loadedData: null,
      emptySearchResult: false,
      page: 1,
      lastPage: 1,
    };
  },
  computed: {
    limitPage() {
      if (this.page) {
        return parseInt(this.page, 10) + 4;
      }
      return 4;
    },
    nextPage() {
      return parseInt(this.page, 10) + 1;
    },
    previousPage() {
      return parseInt(this.page, 10) - 1;
    },
  },
  created() {
    this.loadPage(1);
  },
  methods: {
    async loadPage(page) {
      this.page = page;
      try {
        let response;
        switch (this.loadFrom) {
          case 'programs':
            response = await loadProgramsByPage(page);
            break;
          case 'episodes':
            response = await loadEpisodesByPage(page);
            break;
          case 'videos':
            response = await loadVideosByPage(page);
            break;
          case 'podcasts':
            response = {
              data: {
                data: [],
                lastPage: 1,
              },
            };
            break;
          default:
            response = await loadProgramsByPage(page);
        }
        this.loadedData = response.data.data;
        this.lastPage = response.data.lastPage;
        this.loadFromAPIState.isLoading = false;
      } catch (error) {
        this.loadFromAPIState.error = error.response;
        this.loadFromAPIState.isLoading = false;
      }
    },
    async loadContentCategories() {
      const response = await loadTaxonomyByKey('content-category');
      this.contentCategories = response.data.data;
    },
    createSlideFromAPI(item) {
      const newSlide = {
        title: item.title,
        coverImage: item.coverImage,
        contentCategory: item.contentCategory,
        link: {
          url: item.url,
          target: '_blank',
        },
        parentId: item.id,
        parentType: this.loadFrom,
        syncWithParent: true,
        startPublish: item.startPublish,
        endPublish: item.endPublish ? item.endPublish : null,
      };
      this.$emit('update:allItems', [newSlide, ...this.allItems]);
      this.$emit('update:showLoadFromAPIModal', false);
    },
    async onSearch(event) {
      const searchTerm = event.target.value;
      try {
        let response;
        switch (this.loadFrom) {
          case 'programs':
            response = await searchProgramsInsideModal(searchTerm);
            break;
          case 'episodes':
            response = await searchEpisodesInsideModal(searchTerm);
            break;
          case 'videos':
            response = await searchVideosInsideModal(searchTerm);
            break;
          case 'podcasts':
            response = {
              data: {
                data: [],
                lastPage: 1,
              },
            };
            break;
          default:
            response = await loadProgramsByPage(searchTerm);
        }
        this.loadedData = response.data.data;
        this.lastPage = response.data.lastPage;
        this.emptySearchResult = this.loadedData.length === 0;
        this.loadFromAPIState.isLoading = false;
      } catch (error) {
        this.loadFromAPIState.error = error.response;
        this.loadFromAPIState.isLoading = false;
      }
    },
    clearSearch() {
      this.searchTerm = '';
    },
    isShowPagination() {
      return this.lastPage > 1;
    },
    checkTitleRequired(event) {
      this.titleError = !event.target.value;
    },
    showPaginate(n) {
      if ((n < this.limitPage && n >= this.page) || this.lastPage < 5) {
        return true;
      }
      return (this.lastPage - n) < 5 && (this.lastPage - this.page) < 5;
    },
    isActivePage(n) {
      if (!this.page) {
        return n === 1;
      }
      return this.page.toString() === n.toString();
    },
    getCategoryName(item) {
      return _.get(item, 'contentCategory.name', 'ไม่มีหมวดหมู่');
    },
    getSearchPlaceholder() {
      let placeholder;
      switch (this.loadFrom) {
        case 'programs':
          placeholder = 'ค้นหาชื่อรายการ';
          break;
        case 'videos':
          placeholder = 'ค้นหาชื่อวิดีโอ';
          break;
        case 'episodes':
          placeholder = 'ค้นหาชื่อตอน';
          break;
        case 'podcasts':
          placeholder = 'ค้นหาชื่อพอตแคสต์';
          break;
        default:
          placeholder = 'ค้นหา';
      }
      return placeholder;
    },
    backToNewSlideModal() {
      this.$emit('showAddSliderItemModal');
    },
  },
};
</script>

<style lang="scss" scoped>
@import './src/assets/scss/variables.scss';
@import './src/assets/scss/themes/helpers.scss';

.load-from-api-modal {
  .modal-header {
    display: flex;
    flex-flow: column;
    div {
      width: 100%;
      display: flex;
      flex-flow: row;
    }
    .btn-close {
      position: absolute;
      top: 16px;
      right: 10px;
      background: transparent;
      border: none;
      outline: none;
      transition: color 250ms ease;
      color: $gray-700;
      &:hover {
        color: $red;
      }
    }
    h5 {
      i {
        cursor: pointer;
        margin-right: 10px;
      }
    }
    .dropdown {
      display: block;
      width: 100%;
      margin-top: 20px;
      p {
        margin: 0;
      }
      select {
        width: 100%;
        border: 1px solid $gray-200;
        border-radius: 0.25rem;
        padding: 3px 5px 11px 5px;
        margin: 2px 0 0 0;
      }
    }
  }
  .modal-body {
    @extend .scrollbar;
    .list-container {
      .search-container {
        margin: 20px 0;
        width: 50%;
      }
      .list-item.list-item-action {
        .btn-action {
          width: 70px;
        }
      }
    }
  }
  .pagination-container {
    margin-left: 14px;
    .pagination {
      display: flex;
    }
    .page-link {
      color: $primary;
      background: transparent;
      border: none;
      margin: 0 $spacer * 0.25;
      border-radius: 4px;
      color: #4d4d4c;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 36px;
      height: 36px;
    }
    .page-link:disabled {
      background: #FFF;
    }
    .page-link:last-child {
      margin-right: 0;
    }
    .page-link.active {
      background-color: lighten($primary, 75%);
      color: darken($primary, 5%);
    }
    .page-previous {
      margin-right: $spacer;
    }
    .page-next {
      margin-left: $spacer;
    }
    .page-first, .page-previous, .page-next, .page-last {
      background-color: $gray-100;
    }
  }
}
</style>
